module.exports = __webpack_public_path__ + "img/bg_pic.5d3654cb.png";